// Use string literals to avoid @mui/lab version conflicts
const loadingIndicatorStart = "MuiLoadingButton-loadingIndicatorStart";
const loadingIndicatorEnd = "MuiLoadingButton-loadingIndicatorEnd";

// ----------------------------------------------------------------------

export default function LoadingButton() {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === "soft" && {
            [`& .${loadingIndicatorStart}`]: {
              left: 10,
            },
            [`& .${loadingIndicatorEnd}`]: {
              right: 14,
            },
            ...(ownerState.size === "small" && {
              [`& .${loadingIndicatorStart}`]: {
                left: 10,
              },
              [`& .${loadingIndicatorEnd}`]: {
                right: 10,
              },
            }),
          }),
        }),
      },
    },
  };
}
